export default "__VITE_ASSET___fSiU3vf__"